import { createReducer } from "deox";

import { RequestResponse, RTP, SenderDataResponse } from "@APP/types";

import { clearRtpState, setOrgLogo, setRtpSuccess } from "../actions";

export interface RtpState {
  senderData: SenderDataResponse | null;
  rtpData: RequestResponse | null;
  rtp: RTP | null;
  /** Logo of the requesting organisation, shown in the page header. */
  orgLogo: string | null;
  /**
   * The encoded `rtpKey` URL segment this session was loaded from. The state is
   * persisted so that it survives the round trip out to the payer's bank, so the
   * landing screen uses this to tell an ongoing journey apart from a brand new
   * payment request and reset the session for the latter (LLOYD-392).
   */
  rtpKey: string | null;
}

const defaultState: RtpState = {
  rtpData: null,
  senderData: null,
  rtp: null,
  orgLogo: null,
  rtpKey: null,
};

const rtpReducer = createReducer(defaultState, (handleAction) => [
  handleAction(setRtpSuccess, (state, { payload }) => ({
    ...state,
    rtpData: payload.rtpData,
    senderData: payload.senderData,
    rtp: payload.rtp,
    rtpKey: payload.rtpKey,
  })),
  handleAction(setOrgLogo, (state, { payload }) => ({
    ...state,
    orgLogo: payload,
  })),
  handleAction(clearRtpState, (state) => ({
    ...state,
    ...defaultState,
  })),
]);

export default rtpReducer;
